import styled from "styled-components";
import { primaryColor, primaryColorHover } from "../../../../config/constants";

export const StepperContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* Centrado dentro de su columna en las tablas, pegado a la derecha en la caja
     de totales para que los selectores queden alineados entre si. */
  margin: ${({ $alignRight }) => ($alignRight ? "0 0 0 auto" : "0 auto")};
  padding: 3px;
  width: ${({ $width }) => $width || "92px"};
  border: 1px solid #dcdcdc;
  border-radius: 20px;
  background-color: #fff;
`;
export const StepperButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0;
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 50%;
  background-color: ${primaryColor};
  outline: none;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  &:hover:enabled {
    background-color: ${primaryColorHover};
  }
  &:disabled {
    opacity: 0.35;
    cursor: default;
  }
`;
export const StepperIcon = styled.img`
  width: 11px;
  height: 11px;
`;
export const StepperValue = styled.span`
  padding: 0 4px;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  white-space: nowrap;
`;
